(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sil-judge-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (carousel) => {
      if (carousel.dataset.silReady === 'true') return;
      const source = carousel.querySelector('[data-sil-review-source]');
      const track = carousel.querySelector('[data-sil-review-track]');
      const empty = carousel.querySelector('[data-sil-review-empty]');
      const previous = carousel.querySelector('[data-sil-review-prev]');
      const next = carousel.querySelector('[data-sil-review-next]');
      const status = carousel.querySelector('[data-sil-review-status]');
      const viewport = carousel.querySelector('.sil-review-carousel__viewport');
      const limit = Number(carousel.dataset.reviewLimit || 12);
      let page = 0;
      let cards = [];

      const columns = () => window.matchMedia('(max-width: 749px)').matches
        ? Number(carousel.dataset.columnsMobile || 1)
        : Number(carousel.dataset.columnsDesktop || 4);

      const classifyCards = () => {
        cards.forEach((card) => {
          const hasImage = Boolean(card.querySelector('img'));
          card.classList.toggle('sil-review-card--has-image', hasImage);
          card.classList.toggle('sil-review-card--no-image', !hasImage);
        });
      };

      const update = () => {
        if (!cards.length) return;
        const perPage = Math.max(1, columns());
        const totalPages = Math.max(1, Math.ceil(cards.length / perPage));
        page = Math.min(page, totalPages - 1);
        const gap = Number.parseFloat(getComputedStyle(carousel).getPropertyValue('--sil-review-gap')) || 0;
        const cardWidth = Math.max(0, (viewport.clientWidth - gap * (perPage - 1)) / perPage);
        cards.forEach((card) => {
          card.style.removeProperty('height');
          card.style.setProperty('flex-basis', `${cardWidth}px`, 'important');
          card.style.setProperty('width', `${cardWidth}px`, 'important');
        });
        const tallestCard = Math.ceil(Math.max(...cards.map((card) => card.scrollHeight)));
        cards.forEach((card) => card.style.setProperty('height', `${tallestCard}px`, 'important'));
        track.style.transform = `translate3d(-${page * (viewport.clientWidth + gap)}px,0,0)`;
        if (previous) previous.disabled = page === 0;
        if (next) next.disabled = page >= totalPages - 1;
        if (status) status.textContent = totalPages > 1 ? `${page + 1} / ${totalPages}` : '';
      };

      const collect = () => {
        if (!source) return false;
        const found = Array.from(source.querySelectorAll('.jdgm-carousel-item')).slice(0, limit);
        if (!found.length) return false;
        track.replaceChildren(...found.map((item) => item.cloneNode(true)));
        cards = Array.from(track.children);
        classifyCards();
        empty.hidden = true;
        carousel.dataset.silReady = 'true';
        update();
        return true;
      };

      const seeded = Array.from(track.children).slice(0, limit);
      let hasSeededCards = false;
      if (seeded.length) {
        cards = seeded;
        classifyCards();
        empty.hidden = true;
        carousel.dataset.silReady = 'true';
        update();
        hasSeededCards = true;
      }

      if (!hasSeededCards && !collect() && source) {
        const observer = new MutationObserver(() => {
          if (collect()) observer.disconnect();
        });
        observer.observe(source, { childList:true, subtree:true });
      }

      track.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', update, { once:true });
      });

      previous?.addEventListener('click', () => { page = Math.max(0, page - 1); update(); });
      next?.addEventListener('click', () => { page += 1; update(); });
      window.addEventListener('resize', update, { passive:true });
    };

    const boot = (root = document) => root.querySelectorAll('[data-sil-review-carousel]').forEach(initialize);
    boot();
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
